import { exclusiveBlocks } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function ExclusiveBlocks() {
  return (
    <section id="blocks" className="scroll-mt-32 bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <SectionHeading
            eyebrow="独立与专属版块"
            icon="ri-layout-grid-line"
            title="六个独立板块，玩法各不一样"
            desc="黑料网5独立成型的专属区块，每一块有自己的组织方式和浏览顺序，互不打扰。挑一块进去，就能用最适合它的方式看完。"
          />
          <span className="px-3.5 py-2 rounded-full bg-accent-100 text-accent-900 font-label text-xs whitespace-nowrap self-start lg:self-auto">
            专属区块 · 共 6 个
          </span>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {exclusiveBlocks.map((block) => (
            <article
              key={block.name}
              className="group flex flex-col rounded-lg border border-background-200 bg-background-50 overflow-hidden transition-colors hover:border-primary-300"
            >
              <div className="w-full aspect-[9/7] overflow-hidden bg-background-100">
                <img
                  src={block.image}
                  alt={`黑料网5 ${block.name} 示意图`}
                  title={`黑料网5 ${block.name} 专属板块`}
                  className="w-full h-full object-top transition-transform duration-500 group-hover:scale-[1.03]"
                />
              </div>
              <div className="flex flex-col flex-1 p-5">
                <div className="flex items-center justify-between gap-3">
                  <span className="px-2.5 py-1 rounded-full bg-primary-100 text-primary-800 font-label text-[11px]">
                    {block.tag}
                  </span>
                  <span className="w-7 h-7 flex items-center justify-center rounded-md bg-background-100 text-foreground-600 group-hover:text-primary-700 transition-colors">
                    <i className="ri-arrow-right-up-line text-[15px]"></i>
                  </span>
                </div>
                <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950">
                  {block.name}
                </h3>
                <p className="mt-2 font-body text-sm leading-relaxed text-foreground-600 flex-1">
                  {block.desc}
                </p>
                <div className="mt-4 pt-4 border-t border-background-100 flex flex-wrap gap-2">
                  {block.points.map((point) => (
                    <span
                      key={point}
                      className="px-2.5 py-1 rounded-md bg-secondary-100 text-secondary-900 font-label text-[11px]"
                    >
                      {point}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}